import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { FollowUpKind } from '@/lib/api/types';
import {
  FollowUpsScreen,
  type FollowUpsSearch,
} from '@/features/buying/follow-ups/FollowUpsTable';
import { FOLLOW_UP_KIND_ORDER } from '@/features/buying/follow-ups/model';

/**
 * /purchasing/follow-ups — what in purchasing needs a second look (TASK-0247, INC-3). Un-nested from
 * /purchasing (the `_` suffix) like the order guide, so it does not inherit the PO list's search schema.
 */
const KINDS = new Set<string>(FOLLOW_UP_KIND_ORDER);

export const Route = createFileRoute('/_app/purchasing_/follow-ups')({
  staticData: { crumb: 'Follow-ups' },
  validateSearch: (s: Record<string, unknown>): FollowUpsSearch => ({
    kind:
      typeof s.kind === 'string' && KINDS.has(s.kind)
        ? (s.kind as FollowUpKind)
        : undefined,
    page: Number(s.page) > 1 ? Number(s.page) : undefined,
  }),
  component: FollowUpsRoute,
});

function FollowUpsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <FollowUpsScreen
      search={search}
      onSearch={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }) })}
    />
  );
}
